///foodtablewidget/render/ Get Render /data
export const GET_FOOD_TABLE_WIDGET_RENDER_DATA =
  "GET_FOOD_TABLE_WIDGET_RENDER_DATA";
export const GET_FOOD_TABLE_WIDGET_RENDER_DATA_SUCCESS =
  "GET_FOOD_TABLE_WIDGET_RENDER_DATA_SUCCESS";
export const GET_FOOD_TABLE_WIDGET_RENDER_DATA_ERROR =
  "GET_FOOD_TABLE_WIDGET_RENDER_DATA_ERROR";

///foodtablewidget/checkavailability POST
export const POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY =
  "POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY";
export const POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_SUCCESS =
  "POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_SUCCESS";
export const POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_ERROR =
  "POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_ERROR";

///foodtablewidget/book
export const POST_FOOD_TABLE_WIDGET_BOOK = "POST_FOOD_TABLE_WIDGET_BOOK";
export const POST_FOOD_TABLE_WIDGET_BOOK_SUCCESS =
  "POST_FOOD_TABLE_WIDGET_BOOK_SUCCESS";
export const POST_FOOD_TABLE_WIDGET_BOOK_ERROR =
  "POST_FOOD_TABLE_WIDGET_BOOK_ERROR";

///foodtablewidget/list
export const GET_FOOD_TABLE_WIDGET_LIST = "GET_FOOD_TABLE_WIDGET_LIST";
export const GET_FOOD_TABLE_WIDGET_LIST_SUCCESS =
  "GET_FOOD_TABLE_WIDGET_LIST_SUCCESS";
export const GET_FOOD_TABLE_WIDGET_LIST_ERROR =
  "GET_FOOD_TABLE_WIDGET_LIST_ERROR";

///foodtablewidget/data/
export const GET_FOOD_TABLE_WIDGET_DATA = "GET_FOOD_TABLE_WIDGET_DATA";
export const GET_FOOD_TABLE_WIDGET_DATA_SUCCESS =
  "GET_FOOD_TABLE_WIDGET_DATA_SUCCESS";
export const GET_FOOD_TABLE_WIDGET_DATA_ERROR =
  "GET_FOOD_TABLE_WIDGET_DATA_ERROR";

///foodtablewidget/create
export const POST_FOOD_TABLE_WIDGET_CREATE = "POST_FOOD_TABLE_WIDGET_CREATE";
export const POST_FOOD_TABLE_WIDGET_CREATE_SUCCESS =
  "POST_FOOD_TABLE_WIDGET_CREATE_SUCCESS";
export const POST_FOOD_TABLE_WIDGET_CREATE_ERROR =
  "POST_FOOD_TABLE_WIDGET_CREATE_ERROR";

///foodtablewidget/update
export const PUT_FOOD_TABLE_WIDGET_UPDATE = "PUT_FOOD_TABLE_WIDGET_UPDATE";
export const PUT_FOOD_TABLE_WIDGET_UPDATE_SUCCESS =
  "PUT_FOOD_TABLE_WIDGET_UPDATE_SUCCESS";
export const PUT_FOOD_TABLE_WIDGET_UPDATE_ERROR =
  "PUT_FOOD_TABLE_WIDGET_UPDATE_ERROR";

///foodtablewidget/delete
export const DELETE_FOOD_TABLE_WIDGET_DELETE =
  "DELETE_FOOD_TABLE_WIDGET_DELETE";
export const DELETE_FOOD_TABLE_WIDGET_DELETE_SUCCESS =
  "DELETE_FOOD_TABLE_WIDGET_DELETE_SUCCESS";
export const DELETE_FOOD_TABLE_WIDGET_DELETE_ERROR =
  "DELETE_FOOD_TABLE_WIDGET_DELETE_ERROR";

///foodtablereservationtableassignmentactivitylog/search
export const GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH =
  "GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH";
export const GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_SUCCESS =
  "GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_SUCCESS";
export const GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_ERROR =
  "GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_ERROR";

///foodtablereservationtableassignment/lock
export const POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK =
  "POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK";
export const POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_SUCCESS =
  "POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_SUCCESS";
export const POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_ERROR =
  "POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_ERROR";

///foodtablereservationtableassignment/unlock
export const POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK =
  "POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK";
export const POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_SUCCESS =
  "POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_SUCCESS";
export const POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_ERROR =
  "POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_ERROR";

///foodtablewidget/search
export const GET_FOOD_TABLE_WIDGET_SEARCH = "GET_FOOD_TABLE_WIDGET_SEARCH";
export const GET_FOOD_TABLE_WIDGET_SEARCH_SUCCESS =
  "GET_FOOD_TABLE_WIDGET_SEARCH_SUCCESS";
export const GET_FOOD_TABLE_WIDGET_SEARCH_ERROR =
  "GET_FOOD_TABLE_WIDGET_SEARCH_ERROR";

///payment/authorise
export const GET_PAYMENT_REQUEST_PUBLIC_DATA =
  "GET_PAYMENT_REQUEST_PUBLIC_DATA";
export const GET_PAYMENT_REQUEST_PUBLIC_DATA_SUCCESS =
  "GET_PAYMENT_REQUEST_PUBLIC_DATA_SUCCESS";
export const GET_PAYMENT_REQUEST_PUBLIC_DATA_ERROR =
  "GET_PAYMENT_REQUEST_PUBLIC_DATA_ERROR";
///foodtablereservation/public/render/
export const GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA =
  "GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA";
export const GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_SUCCESS =
  "GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_SUCCESS";
export const GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_ERROR =
  "GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_ERROR";
///foodtablereservation/public/cancel
export const POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL =
  "POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL";
export const POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_SUCCESS =
  "POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_SUCCESS";
export const POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_ERROR =
  "POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_ERROR";

// Task 24278 - request-to-book approve
export const PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE =
  "PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE";
export const PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE_SUCCESS =
  "PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE_SUCCESS";
export const PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE_ERROR =
  "PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE_ERROR";

// Task 24278 - request-to-book decline preview (prefilled editable email)
export const GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW =
  "GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW";
export const GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW_SUCCESS =
  "GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW_SUCCESS";
export const GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW_ERROR =
  "GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW_ERROR";

// Task 24278 - request-to-book decline (send edited email + decline)
export const PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE =
  "PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE";
export const PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_SUCCESS =
  "PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_SUCCESS";
export const PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_ERROR =
  "PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_ERROR";
